<template>
  <preview-sp class="pega-sp-print-area">
    <job-search-preview-detail-sp
      :job-search-result="jobSearchResult"
      :employment-status="jobSearchResult.employmentStatus"
      :pr-codes="jobSearchResult.prCodes"
    />
  </preview-sp>
</template>

<script>
import JobSearchPreviewDetailSp from '@/components/organisms/JobSearchPreviewDetailSp'
import PreviewSp from '@/components/templates/PreviewSp'
import jobSearchPreviewCommon from '@/lib/jobSearchPreviewCommon'

export default {
  components: {
    PreviewSp,
    JobSearchPreviewDetailSp
  },
  // PC・SP共通処理読み込み
  mixins: [jobSearchPreviewCommon]
}
</script>
